<template>
  <div class="wrapper">
    <el-dialog
        :title="rowId ? '编辑白名单' : '新增白名单'"
        :visible.sync="showAddOrEdit"
        width="600px"
        :before-close="cancelFun"
        class="white-list-dialog"
    >
      <div >
        <el-form ref="form" :model="formData" label-width="130px" class="white-list-form">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item
                label="姓名"
                prop="memberName"
                :rules="[
                { required: true, message: '该项不能为空', trigger: 'blur' },
              ]"
            >
              <el-input
                  v-model="formData.memberName"
                  placeholder="请输入姓名"
                  clearable
                  class="form-input"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
                label="身份证号"
                prop="identityNo"
                :rules="[
                { required: true, message: '该项不能为空', trigger: 'blur' },
              ]"
            >
              <el-input
                  v-model="formData.identityNo"
                  placeholder="请输入身份证号"
                  clearable
                  class="form-input"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
                label="手机号"
                prop="mobile"
                :rules="[
                { required: true, message: '该项不能为空', trigger: 'blur' },
              ]"
            >
              <el-input
                  v-model="formData.mobile"
                  placeholder="请输入手机号"
                  clearable
                  class="form-input"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelFun" class="cancel-btn">取 消</el-button>
        <el-button type="primary" @click="submitFun" class="submit-btn">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { addRosterAPI, editRosterAPI, getRosterDetailAPI } from './api'
export default {
  name: 'AddOrEdit',
  props: {
    showAddOrEdit: {
      type: Boolean,
      default: false,
    },
    rowId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      formData: {
        memberName: '',
        mobile: '',
        identityNo: '',
        riskLevel: 1
      }
    }
  },
  mounted() {
    if (this.rowId) this.getRosterDetail();
  },
  methods: {
    // 详情
    async getRosterDetail() {
      this.formData = await getRosterDetailAPI({ id: this.rowId });
    },
    cancelFun() {
      this.$emit("closeDialog");
    },
    submitFun() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          (this.rowId ? editRosterAPI : addRosterAPI)(this.formData).then(
              () => {
                this.$message.success(this.rowId ? "编辑成功" : "新增成功");
                this.$emit("closeDialog", true);
              }
          );
        } else {
          return false;
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
}

.white-list-dialog {
  ::v-deep .el-dialog {
    border-radius: 8px;
    overflow: hidden;
  }

  ::v-deep .el-dialog__header {
    background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
    padding: 20px 24px;
    border-bottom: none;

    .el-dialog__title {
      color: #fff;
      font-size: 18px;
      font-weight: 600;
    }

    .el-dialog__close {
      color: #fff;
      font-size: 20px;

      &:hover {
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }

  ::v-deep .el-dialog__body {
    padding: 24px;
    background: #f5f7fa;
  }

  ::v-deep .el-dialog__footer {
    padding: 16px 24px;
    background: #fff;
    border-top: 1px solid #e4e7ed;
  }

  ::v-deep .el-form-item__label {
    font-weight: 500;
    color: #606266;
    font-size: 14px;
  }

  ::v-deep .el-form-item {
    margin-bottom: 20px;
  }
}

.scroll-wrap {
  max-height: 65vh;
  overflow-y: auto;
  padding-right: 8px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;

    &:hover {
      background: #a8a8a8;
    }
  }
}

.white-list-form {
  .form-input {
    width: 100%;
    max-width: 400px;

    ::v-deep .el-input__inner {
      border-radius: 4px;
      transition: all 0.3s ease;

      &:focus {
        border-color: #409EFF;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
      }

      &:hover {
        border-color: #c0c4cc;
      }
    }
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;

  .cancel-btn {
    padding: 10px 24px;
    border-radius: 4px;
    font-weight: 500;
    transition: all 0.3s ease;

    &:hover {
      color: #409EFF;
      border-color: #409EFF;
      background-color: #ecf5ff;
    }
  }

  .submit-btn {
    padding: 10px 24px;
    border-radius: 4px;
    font-weight: 500;
    transition: all 0.3s ease;
    background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
    border: none;

    &:hover {
      opacity: 0.9;
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .white-list-dialog {
    ::v-deep .el-dialog {
      width: 95% !important;
      margin: 5vh auto;
    }
  }

  .white-list-form {
    .form-input {
      max-width: 100% !important;
    }
  }
}
</style>
